import React from "react";
import { ethers } from "ethers";
import { useEffect, useState } from "react";
import { cpCTMTConAdd, treasurerAdd } from "./ConAddsAndABIs"

function Navigation(){

    const [walletAddress, setWalletAddress] = useState("");
    const [tradingRole, setTradingRole] = useState("");
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();

    const cpCTMTABI = 
        [
            {
                "inputs": [
                  {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                  }
                ],
                "name": "managerOrProvider",
                "outputs": [
                  {
                    "internalType": "string",
                    "name": "",
                    "type": "string"
                  }
                ],
                "stateMutability": "view",
                "type": "function"
              }
        ]

    const cpCTMTContract = new ethers.Contract(cpCTMTConAdd, cpCTMTABI, signer);

    async function requestAccount() {
        console.log('Requesting account...');

        if(window.ethereum) {
            console.log('detected');

                try {
                    const accounts = await window.ethereum.request({
                        method: "eth_requestAccounts",
                    });
                    setWalletAddress(accounts[0]);
                } catch (error) {
                    console.log('Error connecting');
                }
            
        } else {
            alert('Meta Mask not detected')
        }
    }

    return(
        <div>
                <a href="/Home">Home</a>

                <p style={{"color":"white"}}>  <button
                
                    onClick={requestAccount}    

                    >Connect Wallet
                    
                    </button>  Address: {walletAddress} </p>
        </div>)
}

export default Navigation;